export enum ETipoFotoVistoria {
  Imagem = 1,
  Video = 2,
}

export enum ESituacao {
  Ativo = 'Ativo',
  Inativo = 'Inativo',
}

export enum EPhotoSection {
  moto = 'moto',
  documentos = 'documentos',
  fotosExtras = 'fotosExtras',
  frentePesados = 'frentePesados',
  traseiraPesados = 'traseiraPesados',
  lateralEsquerdaCaminhao = 'lateralEsquerdaCaminhao',
  lateralDireitaCaminhao = 'lateralDireitaCaminhao',
  interior = 'interior',
  motor = 'motor',
  pneus = 'pneus',
  frenteLeves = 'frenteLeves',
  traseiraLeves = 'traseiraLeves',
  lateralEsquerdaLeves = 'lateralEsquerdaLeves',
  lateralDireitaLeves = 'lateralDireitaLeves',
  acessorios = 'acessorios',
  frenteOnibus = 'frenteOnibus',
  traseiraOnibus = 'traseiraOnibus',
  lateralEsquerdaOnibus = 'lateralEsquerdaOnibus',
  lateralDireitaOnibus = 'lateralDireitaOnibus',
}